export const goodRank = {
  clickTab: 'n.5209.10839.0', // 热卖复购榜单二级页-需求词点击
  seeMore: 'n.5209.10849.0', // 热卖复购榜单二级页-需求词查看更多点击
  goodExpose: 'n.5209.7711.0', // 热卖复购榜单二级页-商品曝光
  chooseFormate: 'n.5209.96.0', // 热卖复购榜单二级页-选规格点击
  chooseFormateClose: 'n.5209.97.0', // 热卖复购榜单二级页-收起点击
  goodAdd: 'n.5209.10.0', // 热卖复购榜单二级页-加购物车点击
  goodMin: 'n.5209.11.0', // 热卖复购榜单二级页-减购物车点击
  goodGoDetail: 'n.5209.262.0', // 热卖复购榜单二级页-跳转详情点击
  clickFloatCart: 'n.5209.8970.0' // 热卖复购榜单二级页-悬浮购物车按钮点击
}
